import { BulkAssignCompetenciesPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useJobCatalogTreeVisibility } from 'modules/job_catalog/hooks/useJobCatalogTreeVisibility'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const BulkAssignCompetenciesPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const { canSeeImport, canSeeCompetencies } = useJobCatalogTreeVisibility()

  const { data, loading, error } = useQuery(BulkAssignCompetenciesPageDocument)
  const treeId = data?.jobCatalog.treesConnection.nodes?.[0]?.id

  return (
    <ResponsivePage.Body
      authorized={canSeeImport && canSeeCompetencies && Boolean(treeId)}
      loading={loading}
      error={error}
    >
      <NuvoImporter
        importType="competencies_competency_assignment_importer"
        companyId={company.id}
        locale={locale}
        metadata={{ tree_id: [Number(treeId)] }}
        isEdition
      />
    </ResponsivePage.Body>
  )
}

export default BulkAssignCompetenciesPage
